import {useCallback} from "react";
import {useBasket} from "@/entities/basket";
import {Product, getMinimalProductPrice} from "@/entities/product";
import {useAddToBasket} from "../model/useAddToBasket";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";

type Props = {
    product: Product;
    productDataId?: number | null;
};

export const useBasketAction = ({product, productDataId = null}: Props) => {
    const {addToBasket, loading} = useAddToBasket();
    const {inBasket} = useBasket();
    const isInBasket = inBasket({productId: product.id, productDataId});

    const {basketStore} = useStoreMobx();

    // const handleClick = useCallback(async () => {
    const handleAddToBasket = useCallback(async () => {
        if (isInBasket) {
            basketStore.getBasket();
            return;
        }

        await addToBasket({
            productId: product.id,
            productDataId,
            article: product.article,
            price: getMinimalProductPrice(product),
        });
    }, [addToBasket, basketStore, isInBasket, product, productDataId]);

    return {
        isInBasket,
        loading,
        handleAddToBasket,
    };
};
